"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processInstanceV2 = exports.surgeryProcessInstance = exports.processInstance = void 0;
exports.processInstance = {
    caseUid: "83ffb36c-997b-47a6-8253-25af87a626d7",
    isChargeable: true,
    errors: [],
    caseType: "EPIC_EMBEDDED",
    tenantId: {
        uuid: "4E3B6258-9DD9-444C-9604-B81A9B67102B"
    },
    healthSystemTenantId: {
        uuid: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59"
    },
    guid: {
        uuid: "83ffb36c-997b-47a6-8253-25af87a626d6"
    },
    serviceLine: "RADIOLOGY",
    status: "IN_PROGRESS",
    qaStatus: null,
    documentImprovements: [],
    autoCancelled: false,
    gender: "M",
    dateOfBirth: "1980-07-26",
    age: null,
    hl7InsurancePayerId: null,
    hl7InsurancePlanId: null,
    cmxInsurancePayerId: null,
    sharedDiagnosisCodes: [],
    invoices: [
        {
            type: "assembled",
            errorMessages: [],
            department_code: "10030010328",
            department: {
                name: "test",
                code: "10030010328"
            },
            fee_schedule: "76805",
            patient_type: "",
            guid: "85d55ea8-41df-4a49-9e79-6c21065a6c2c",
            date_of_service: "2022-08-11",
            deleted: false,
            billing_location: "WDSOM7MRSHBRK",
            billing_area: null,
            division: "WDSOM7MRSHBRK",
            facility: "ICMPB WDH",
            filler_number: {
                number: "CDT487731855757",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            billing_provider_name: "NEDELKA, SHANNON",
            billing_provider_number: {
                number: "1787335",
                issuer: "EPIC",
                type: "EPIC"
            },
            ordering_provider_name: "DECKER, THOMAS",
            ordering_provider_number: {
                number: "1132127",
                issuer: "EPIC",
                type: "EPIC"
            },
            referring_provider_name: "DECKER, THOMAS",
            referring_provider_number: {
                number: "1132127",
                issuer: "EPIC",
                type: "EPIC"
            },
            performing_provider_name: "NEDELKA, SHANNON",
            performing_provider_number: {
                number: "1787335",
                issuer: "EPIC",
                type: "EPIC"
            },
            transactions: [
                {
                    errorMessages: [],
                    guid: "120228",
                    sequence_number: 1,
                    //"department_code": "WDH_WDMRISOM",
                    technical_code: null,
                    source_transaction_id: "3",
                    deleted: false,
                    fee_schedule: "5000356",
                    place_of_service: "BWH_LNWTHYND",
                    procedure: {
                        errorMessages: [],
                        procedure_code: "73221",
                        units: 1.0,
                        sequence_number: 1,
                        evidence: [],
                        custom_cpt: false,
                        additionalProperties: {
                            id: 1373
                        }
                    },
                    modifiers: [
                        {
                            modifier_code: "LT",
                            modifier_type: "PRO",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 1256
                            }
                        }
                    ],
                    diagnoses: [
                        {
                            diagnosis_code: "C91.10",
                            sequence_number: 1,
                            shared: false,
                            active: false,
                            evidence: [],
                            additionalProperties: {
                                id: 1597
                            }
                        },
                        {
                            diagnosis_code: "M19.012",
                            sequence_number: 2,
                            shared: false,
                            active: false,
                            evidence: [
                                {
                                    type: "Categorical",
                                    score: 0.15065338242726156,
                                    feature: {
                                        category: "Upper Extremity",
                                        field: "body_region",
                                        type: "categorical"
                                    }
                                },
                                {
                                    type: "Ngram",
                                    score: 0.04011723556329749,
                                    feature: {
                                        slop: 0,
                                        field: "raw_body",
                                        in_order: true,
                                        ngram: "degen",
                                        type: "ngram",
                                        spans: [
                                            {
                                                start: 865,
                                                end: 877,
                                                level: "ngram",
                                                content: "degenerative"
                                            },
                                            {
                                                start: 843,
                                                end: 917,
                                                level: "sentence",
                                                content: " Bones: There is mild degenerative change of the acromioclavicular joint. "
                                            },
                                            {
                                                start: 980,
                                                end: 992,
                                                level: "ngram",
                                                content: "degenerative"
                                            },
                                            {
                                                start: 964,
                                                end: 1042,
                                                level: "sentence",
                                                content: "There is cystic degenerative change of the greater tuberosity of the humerus. "
                                            },
                                            {
                                                start: 1571,
                                                end: 1583,
                                                level: "ngram",
                                                content: "degenerative"
                                            },
                                            {
                                                start: 1565,
                                                end: 1642,
                                                level: "sentence",
                                                content: " Mild degenerative change of the acromioclavicular and glenohumeral joints.\\n "
                                            }
                                        ]
                                    }
                                },
                                {
                                    type: "Ngram",
                                    score: 0.006560534652917505,
                                    feature: {
                                        slop: 0,
                                        field: "exam_type",
                                        in_order: true,
                                        ngram: "left",
                                        type: "ngram",
                                        spans: []
                                    }
                                },
                                {
                                    type: "Ngram",
                                    score: 0.006560534652917505,
                                    feature: {
                                        slop: 0,
                                        field: "exam_type",
                                        in_order: true,
                                        ngram: "shoulder",
                                        type: "ngram",
                                        spans: []
                                    }
                                },
                                {
                                    type: "Ngram",
                                    score: 0.006560534652917505,
                                    feature: {
                                        slop: 2,
                                        field: "exam_type",
                                        in_order: true,
                                        ngram: "shoulder left",
                                        type: "ngram",
                                        spans: []
                                    }
                                },
                                {
                                    type: "Ngram",
                                    score: 0.006560534652917505,
                                    feature: {
                                        slop: 1,
                                        field: "exam_type",
                                        in_order: true,
                                        ngram: "without left",
                                        type: "ngram",
                                        spans: []
                                    }
                                }
                            ],
                            additionalProperties: {
                                id: 1594
                            }
                        }
                    ]
                }
            ],
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        }
    ],
    cancelled: false
};
exports.surgeryProcessInstance = __assign(__assign({}, exports.processInstance), { serviceLine: "SURGERY" });
var transformToNewFormat = function (processInstance) {
    processInstance.invoices.forEach(function (invoice) {
        invoice.transactions.forEach(function (txn) {
            if (txn.modifiers) {
                txn.procedure = txn.procedure || {};
                txn.procedure.modifier_codes = txn.modifiers;
                txn.modifiers = [];
            }
        });
    });
    return processInstance;
};
exports.processInstanceV2 = transformToNewFormat(JSON.parse(JSON.stringify(exports.processInstance))); // Deep cloning processInstance
//# sourceMappingURL=process-instance.js.map